// extracted by mini-css-extract-plugin
export var card = "_ix-5";
export var cardSelected = "_ix-4";
export var image = "_ix-3";
export var modal = "_ix-0";
export var modalContent = "_ix-1";
export var table = "_ix-2";